import type { JSX } from '@builder.io/qwik';
import { component$, useContext } from '@builder.io/qwik';
import { cva } from 'class-variance-authority';
import {
  getCSSColorBg,
  getCSSColorText,
  getCSSSizeSmText,
} from '~/utilities/getCSS';
import NavItem from '~/components/Layout/Header/Desktop/NavItem';
import { NavContext } from '~/contexts/NavContext';
import { getHeaderHeight } from '~/utilities/getHeaderHeight';
import { AppDataContext } from '~/contexts/AppDataContext';
import type { NavItemType } from '~/types/NavItemType';

const dropdownMobileClasses = cva('py-4 px-2.5', {
  variants: {
    color: getCSSColorText(),
    background: getCSSColorBg(),
    sizeSm: getCSSSizeSmText(),
    level: {
      0: 'fixed left-0 w-full',
      1: '',
    },
    active: {
      false: '',
      true: '',
    },
  },
  compoundVariants: [
    {
      level: 0,
      active: false,
      class: 'hidden',
    },
  ],
});

export default component$(
  ({ item, activeItem, level }: NavItemType): JSX.Element => {
    const appData = useContext(AppDataContext);
    const { theme } = useContext(NavContext);
    const clampedLevel = level >= 1 ? 1 : 0;

    const headerHeight = getHeaderHeight(
      appData.themeComponents,
      appData.payloadToSSR.layout,
      { screenSize: 'Small' }
    );

    return (
      <div
        style={{
          top: headerHeight,
          height: `calc(100vh - ${headerHeight})`,
        }}
        class={dropdownMobileClasses({
          background: theme.SubMenuBackgroundColor.value,
          color: theme.LinkColorTypeNormal.value,
          sizeSm:
            appData.themeComponents.header.hamburgerMenuSubLinksFontSizeSmall
              .value,
          level: clampedLevel,
        })}
      >
        <ul class='grid grid-cols-2 gap-x-2 gap-y-5'>
          {item.children?.map((each, index) => {
            return (
              <NavItem
                key={index}
                item={each}
                activeItem={activeItem}
                level={level + 1}
              />
            );
          })}
        </ul>
      </div>
    );
  }
);
